<!--手工填报历史值-->
<template>
	<div class="historical_value_body">
		<!--操作表单-->
		<div class="page_top_form">
			<el-form ref="form" label-width="100px">
				<el-form-item label="变量名搜索">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="输入类型">
					<el-select v-model="form.region" placeholder="请选择类型">
						<el-option label="日" value="1"></el-option>
						<el-option label="月" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间类型" v-show="form.region!=2">
					<el-select v-model="dateTimeType" placeholder="请选择类型">
						<el-option label="5分钟" value="5"></el-option>
						<el-option label="15分钟" value="15"></el-option>
						<el-option label="30分钟" value="30"></el-option>
						<el-option label="1小时" value="60"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期">
					<el-date-picker :type="dateType" placeholder="选择日期" v-model="form.dateTime" style="width: 100%;"></el-date-picker>
				</el-form-item>
				<el-form-item label="">
					<el-button type="primary" size="mini" @click="search()">查询</el-button>
					<!--<el-button type="primary" size="mini" @click="batchEdit">批量确认</el-button>-->
					<!--<el-button type="primary" size="mini" @click="exportReport">导出当前页</el-button>
					<el-button type="primary" size="mini" @click="exportReport">导出所有</el-button>-->
				</el-form-item>
			</el-form>
		</div>
		<!--列表显示-->
		<div class="tableList" style="padding: 0 20px;">
			<dayFiveTable ref="dayFiveTableRefs" :dataList="dataList" :loading="loading" @singleDetermine="singleDetermine" v-show="form.region!=2&&dateTimeType==5"></dayFiveTable>
			<dayFifteenTable ref="dayFifteenTableRefs" :dataList="dataList" :loading="loading" @singleDetermine="singleDetermine" v-show="form.region!=2&&dateTimeType==15"></dayFifteenTable>
			<dayThirtyTable ref="dayThirtyTableRefs" :dataList="dataList" :loading="loading" @singleDetermine="singleDetermine" v-show="form.region!=2&&dateTimeType==30"></dayThirtyTable>
			<daySixtyTable ref="daySixtyTableRefs" :dataList="dataList" :loading="loading" @singleDetermine="singleDetermine" v-show="form.region!=2&&dateTimeType==60"></daySixtyTable>
			<!--月表格-->
			<monthTable ref="monthTableRefs" :dataList="dataList" :loading="loading" @singleDetermine="singleDetermine" v-show="form.region==2"></monthTable>
		</div>
		<elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange" @handleSizeChange="handleSizeChange" />
	</div>
</template>
<script>
	import elPagination from "@/components/module/elComponents/elPagination.vue"
	import monthTable from "@/page/manuallyFillIn/subPage/monthTable.vue"
	import dayFiveTable from "@/page/manuallyFillIn/subPage/dayFiveTable.vue"
	import dayFifteenTable from "@/page/manuallyFillIn/subPage/dayFifteenTable.vue"
	import dayThirtyTable from "@/page/manuallyFillIn/subPage/dayThirtyTable.vue"
	import daySixtyTable from "@/page/manuallyFillIn/subPage/daySixtyTable.vue"
	export default {
		components: {
			elPagination,
			monthTable,
			dayFiveTable,
			dayFifteenTable,
			dayThirtyTable,
			daySixtyTable,
		},
		props: {},
		data() {
			return {
				form: {
					name: '',
					region: '2',
					dateTime: new Date(),
				},
				dateTimeType: "60",
				dateType: "month",
				dataList: [],
				loading: false,
				pageIndex: 1,
				pageSize: 11,
				total: 0,
				columnValueList: [],
				monthColumnList: [],
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.search()
		},
		destroyed() {},
		computed: {},
		watch: {
			"form.region" (nv, ov) {
				if(nv == 1) {
					this.dateType = "date"
				} else {
					this.dateType = "month"
				}
				this.search()
			},
		},
		methods: {
			singleDetermine(row) {
				let time = new Date(this.form.dateTime).getTime()
				//将最大值和最小值更新进去（需要过滤排序）
                let list=this.valueList(row)
                row['max']=Math.max(...list)
                row['min']=Math.min(...list)
				this.$api.historyApi.updateHistory(JSON.stringify(row), this.dateType, time, respon => {
					this.$message(respon)
				}, error => {
					this.$message.error(error)
				})
			},
			pageindexChange(val) {
				this.pageIndex = val;
				this.search()
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.pageIndex = 1;
				this.search()
			},
			search() {
				this.loading = true
				this.$api.manualApi.getManualVariable(this.pageIndex, this.pageSize, respon => {
					let dateTime = new Date(this.form.dateTime).getTime()
					this.$api.historyApi.searchVariableCustomizeHistory(respon.data.map(item => item.CreateVname).join(','), dateTime, this.dateType, respon2 => {
						if(!isempty(respon2)) {
							this.dataList = respon2
						} else {
							this.$message.warning("本日无数据")
							this.dataList = []
						}
						this.loading = false
					})
					this.total = respon.total
					//查询历史值
				}, respon => {
					this.$message.error(respon);
				})

			},
			batchEdit() {
				//批量确认先不做
				let dataList = []
				switch(this.dateType) {
					case "date":
						switch(this.dateTimeType) {
							case "5":
								dataList = this.$refs.dayFiveTableRefs.dataList
								break;
							case "15":
								dataList = this.$refs.dayFifteenTableRefs.dataList
								break;
							case "30":
								dataList = this.$refs.dayThirtyTableRefs.dataList
								break;
							case "60":
								dataList = this.$refs.daySixtyTableRefs.dataList
								break;
						}
						break;
					case "month":
						dataList = this.$refs.monthTableRefs.dataList
						break;
				}
				dataList.forEach(item => {

				})
			},
			valueList(obj) {
				let list=[]
				if(!isempty(obj)) {
					for(let key in obj) {
                       if(key.indexOf('value')!=-1){
                       	   list.push(obj[key])
                       }
					}
				}
				return list

			},
			exportReport() {

			}
		}
	}
</script>

<style scoped>
	.historical_value_body {
		width: 100%;
		height: 100%;
		background-color: white;
	}
</style>